<template>
  <div class="login_wrapper">
    <div>
      <el-input
        v-model="userslug"
        type="text"
        placeholder="username"
      />
      <button
        class="login"
        type="button"
        @click="login"
      >
        go preivew
      </button>
    </div>
  </div>
</template>

<script>
import _$ from 'js/api/getdata'
import { getLanguage } from 'js/util/util'

export default {
  name: 'Login',
  data() {
    return {
      userslug: '',
    }
  },
  methods: {
    common(name) {
      _$.postData('/v2/user/login?account_id=-1&uid=-1&S=undefined', {
        user_slug: this.userslug,
        bind_type: false,
        password: 'WatxfWY0uaFGegvnyN+4HcGljrTtYbZ1+Mz0UfZOqtWJ7nGo+NfkDxEqRXu2Qk8M6Z+neKJn+VCTzdaWRSWUgAqyU5/NwkLAWB8daCF3Qy5RBiBWIFOAVxKYGi7PqDnSh1iffkTqhM+dMLiN4unPSU7HcgmBcZICF777hLKO/Ps=',
      }).then(() => {
        this.$router.push({
          name,
          params: { from: 'ent', neid: '1937946138' },
          query: {
            from: 'ent',
            language: getLanguage(),
            other: JSON.stringify({
              path_type: 'ent',
              sort: '',
              orderby: '',
              limit: 50,
              offset: 0,
              include_deleted: false,
              neid: 1750062894,
              neid_dir: 1750062894,
            }),
          },
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    login() {
      this.common('file')
    },
  },
}
</script>

<style scoped lang="less">
.login_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  div {
    display: flex;
    align-items: center;

    .login {
      padding: 8px 10px;
      border-radius: 2px;
      border: 1px solid #409eff;
      margin: 24px;
      color: #409eff;
      white-space: nowrap;
    }
  }
}
</style>
